<script setup lang="ts">
import AiJobsDataTable from '@/features/ai-jobs/components/AiJobsDataTable.vue'

definePage({
  path: '/ai-jobs',
  name: 'ai-jobs.overview',
  meta: {
    title: 'AI-vacatures',
    permission: {
      resource: 'Job',
      level: 'Read',
    },
  },
})
</script>

<template>
  <div class="space-y-5">
    <Card>
      <template #content>
        <AiJobsDataTable />
      </template>
    </Card>
  </div>
</template>
